import { useAppContext } from '@contexts/app';
import { initialState } from '@contexts/app/constants';
import { usePanel } from '@hooks/usePanel';
import { localStore } from '@utils/localStore';
import { useEffect } from 'react';

export const useImpersonateAuth = () => {
  const { isLogged, setData } = useAppContext();
  const { panel } = usePanel();

  const impersonate = localStore.getItem('app-impersonate');
  const startImpersonate = localStore.getItem('app-start-impersonate');

  useEffect(() => {
    if (!panel || !impersonate || startImpersonate) return;
    localStore.removeItem('app-impersonate');
    if (!isLogged) return;
    localStore.removeItem('app-user');
    setData((prev) => ({ ...initialState, ...prev.admin }));
  }, [isLogged, panel, impersonate, startImpersonate, setData]);
};
